import { render, staticRenderFns } from "./Fact.vue?vue&type=template&id=451556e0&scoped=true&"
import script from "./Fact.vue?vue&type=script&lang=js&"
export * from "./Fact.vue?vue&type=script&lang=js&"
import style0 from "./Fact.vue?vue&type=style&index=0&id=451556e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451556e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow})
